/**
 * Cookie notice — stores consent; separate from product disclaimer.
 */
(function () {
  var KEY = "dm_cookie_consent";
  var banner = document.getElementById("dm-cookie-banner");
  if (!banner) return;

  function accepted() {
    try {
      return window.localStorage.getItem(KEY) === "1";
    } catch (e) {
      return false;
    }
  }

  function accept() {
    try {
      window.localStorage.setItem(KEY, "1");
    } catch (e) {
      /* ignore */
    }
    banner.hidden = true;
    banner.setAttribute("aria-hidden", "true");
  }

  if (accepted()) {
    banner.hidden = true;
    return;
  }

  banner.hidden = false;
  banner.removeAttribute("aria-hidden");

  var btn = banner.querySelector("[data-cookie-accept]");
  if (btn) {
    btn.addEventListener("click", accept);
  }
})();
